import { render } from "./JobApprovalsView.vue?vue&type=template&id=1c3497e8"
import script from "./JobApprovalsView.ts?vue&type=script&lang=js"
export * from "./JobApprovalsView.ts?vue&type=script&lang=js"

import "./JobApprovalsView.vue?vue&type=style&index=0&id=1c3497e8&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/jkm4GJjzS/0/titletool/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__